module.exports = "https://r.nearpod.com/assets/media/image/item-placeholder-12382e95978b029fba296f04f73d730a.svg";